import React from 'react';
import UserWelcomeContainer from './comp/userWelcome/UserWelcomeConnector';
import './manageDashboardPage.scss';
import VendorOverchargesChart from "./comp/vendorOverchargesChart/VendorOverchargesChartConnector";
import LinesDataContainer from './comp/linesData/LinesDataConnector';
import TransactionSummary from './comp/transactionSummary/TransactionSummaryConnector';

const title = "Use Tax Manager";

class ManageDashboardPage extends React.Component {
  componentWillMount() {
    document.title = title;
  }

  render() {
    return (
      <div className="manage-dashboard__page react-page">
        <h1>{ title }</h1>
        <hr />
        <div className="manage-dashboard-grid-container">
          <div className="manage-dashboard-grid-container__grid-column">
            <UserWelcomeContainer />
            <VendorOverchargesChart />            
          </div>
          
          <div className="manage-dashboard-grid-container__fixed-column">
            <div className="manage-dashboard-grid-container__line-data">
              <LinesDataContainer />
              <TransactionSummary />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ManageDashboardPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/ManageDashboardPage.js